import { RECEIVE_DATA_OBJECTS, REMOVE_DATA_OBJECTS, STORE_DATA_OBJECTS } from '@inpart-io/devtools-vue';
import { agreementDetailsManager } from '@inpart-io/padme-iap';
import { type IAgreement } from '@inpart-io/padme-iap';
import { type ActionTree } from 'vuex';

import { MANDATORY_FIELD_CONFIGURATION_MODULE } from '../mandatory-field-configuration-module';

export const DRAFT_AGREEMENT = 'setStatusDraft';
export const ACTIVE_AGREEMENT = 'setStatusActive';
export const EXPIRED_AGREEMENT = 'setStatusExpired';
export const TERMINATED_AGREEMENT = 'setStatusTerminated';
export const ABORTED_AGREEMENT = 'setStatusAborted';
export const MAKE_PUBLIC = 'makePublic';
export const MAKE_PRIVATE = 'makePrivate';
export const REMOVE_FROM_STORE = 'removeFromStore';
export const RETRIEVE_MANDATORY_CONFIGURATIONS = 'retrieveMandatoryConfigurations';

export const actions: ActionTree<IAgreement, unknown> = {
    async [DRAFT_AGREEMENT](context, { agreementDetailId, properties }: { agreementDetailId: number; properties?: string }) {
        const result = await agreementDetailsManager.changeStatusToDraft(agreementDetailId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [ACTIVE_AGREEMENT](context, { agreementDetailId, properties }: { agreementDetailId: number; properties?: string }) {
        const result = await agreementDetailsManager.changeStatusToActive(agreementDetailId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [EXPIRED_AGREEMENT](context, { agreementDetailId, properties }: { agreementDetailId: number; properties?: string }) {
        const result = await agreementDetailsManager.changeStatusToExpired(agreementDetailId, { properties });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [TERMINATED_AGREEMENT](
        context,
        {
            agreementDetailId,
            terminateAmendments = false,
            date,
            reason,
            reasonDetail,
            properties
        }: { agreementDetailId: number; terminateAmendments: boolean; properties?: string; date?: string; reason: number; reasonDetail: string }
    ) {
        const result = await agreementDetailsManager.changeStatusToTerminated(agreementDetailId, date, reason, reasonDetail, {
            terminateAmendmentsFlag: terminateAmendments,
            properties
        });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [ABORTED_AGREEMENT](
        context,
        {
            agreementDetailId,
            terminateAmendments = false,
            date,
            reason,
            reasonDetail,
            properties
        }: { agreementDetailId: number; terminateAmendments: boolean; date: string; reason: number; reasonDetail: string; properties?: string }
    ) {
        const result = await agreementDetailsManager.changeStatusToAborted(agreementDetailId, date, reason, reasonDetail, {
            terminateAmendmentsFlag: terminateAmendments,
            properties
        });
        void context.dispatch(STORE_DATA_OBJECTS, { dataObjectList: [result] });
    },
    async [MAKE_PUBLIC](context, { agreementDetailId, properties }: { agreementDetailId: number; properties?: string }) {
        const result = await agreementDetailsManager.makeAgreementDetailPublic(agreementDetailId, { properties });
        if (result !== undefined) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        }
    },
    async [MAKE_PRIVATE](context, { agreementDetailId, properties }: { agreementDetailId: number; properties?: string }) {
        const result = await agreementDetailsManager.makeAgreementDetailPrivate(agreementDetailId, { properties });
        if (result !== undefined) {
            context.commit(RECEIVE_DATA_OBJECTS, { dataObjectList: [result] });
        }
    },
    async [RETRIEVE_MANDATORY_CONFIGURATIONS](context, { dobjId }: { dobjId: number }): Promise<number[]> {
        const configs = await agreementDetailsManager.getMandatoryConfiguration(dobjId);
        void context.dispatch(`${MANDATORY_FIELD_CONFIGURATION_MODULE}/${STORE_DATA_OBJECTS}`, { dataObjectList: configs }, { root: true });
        return configs.map((config) => {
            return config.dobjId;
        });
    },
    [REMOVE_FROM_STORE](context, { agreementDetailId }: { agreementDetailId: number }) {
        context.commit(REMOVE_DATA_OBJECTS, { dobjId: agreementDetailId });
    }
};
